import { createUppyInstance } from '~/common/utils/uppy.util.js';

export function useThermCustomReport() {
  async function uploadFiles(files, service = null) {
    const uppy = createUppyInstance({
      attachment_config: {
        meta: {
          service: service || 'therm',
          id: 'upload',
        },
      },
    });
    uppy.addFiles(files);

    const waitForUploads = () => {
      return new Promise((resolve, reject) => {
        uppy.on('complete', (result) => {
          if (result.failed.length > 0) {
            reject(new Error('Some files failed to upload'));
          }
          else {
            resolve(result);
          }
        });
      });
    };

    try {
      await waitForUploads();
      logger.log('Files uploaded successfully');
    }
    catch (error) {
      logger.error('Error during upload:', error);
    }
  }

  function getAttachmentDetails(file) {
    if (!file)
      return null;
    return {
      uid: file.uid || crypto.randomUUID(),
      service: file.service_object || file.service,
      file_name: file.name || file.file_name,
      file_size: file.size || file.file_size,
      file_type: file.type || file.file_type,
    };
  }

  return {
    uploadFiles,
    getAttachmentDetails,
  };
}
